(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lactovia-premium-v2"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lactovia-premium-v2')) {
  customElements.define('lactovia-premium-v2', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const root = this;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const desktop = window.matchMedia('(min-width: 900px) and (min-height: 700px)');
      const mobile = window.matchMedia('(max-width: 700px)');
      const menuButton = root.querySelector('.menu-button');
      const menu = root.querySelector('.mobile-menu');
      const header = root.querySelector('.site-header');
      const story = root.querySelector('.story');
      const stage = root.querySelector('.story__stage');
      const panels = [...root.querySelectorAll('.story-panel')];
      const chapterButtons = [...root.querySelectorAll('[data-goto]')];
      const hero = root.querySelector('.hero__scene');
      const cinema = root.querySelector('.cinema');
      const inertBeforeMenu = new Map();
      let activeChapter = -1;
      let scrollStory = false;
      let ticking = false;
      let touchY = null;
      const clamp = (n, lo = 0, hi = 1) => Math.min(hi, Math.max(lo, n));

      const setMenu = (open, restoreFocus = false) => {
        menu.hidden = !open;
        menuButton.setAttribute('aria-expanded', String(open));
        menuButton.setAttribute('aria-label', open ? menuButton.dataset.closeLabel : menuButton.dataset.openLabel);
        root.classList.toggle('menu-open', open);
        if (open) {
          [...root.children].filter((element) => element !== header).forEach((element) => {
            if (!inertBeforeMenu.has(element)) inertBeforeMenu.set(element, element.inert);
            element.inert = true;
          });
          header.setAttribute('role', 'dialog');
          header.setAttribute('aria-modal', 'true');
          header.setAttribute('aria-label', header.dataset.dialogLabel);
          menu.querySelector('a').focus();
        } else {
          inertBeforeMenu.forEach((wasInert, element) => { element.inert = wasInert; });
          inertBeforeMenu.clear();
          header.removeAttribute('role');
          header.removeAttribute('aria-modal');
          header.removeAttribute('aria-label');
          if (restoreFocus) menuButton.focus();
        }
      };
      this.closeMenu = () => setMenu(false);
      menuButton.addEventListener('click', () => setMenu(menu.hidden, !menu.hidden), { signal });
      menu.addEventListener('click', (event) => { if (event.target.closest('a')) setMenu(false); }, { signal });
      root.addEventListener('keydown', (event) => {
        if (menu.hidden) return;
        if (event.key === 'Escape') { setMenu(false, true); return; }
        if (event.key === 'Tab') {
          const links = [...menu.querySelectorAll('a')];
          const first = header.querySelector('.wordmark');
          const last = links[links.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
        const steps = { ArrowDown: 48, ArrowUp: -48, PageDown: menu.clientHeight * .85, PageUp: -menu.clientHeight * .85, Home: -menu.scrollHeight, End: menu.scrollHeight };
        let distance = steps[event.key];
        if (event.key === ' ' && event.target.tagName !== 'BUTTON') distance = menu.clientHeight * (event.shiftKey ? -.85 : .85);
        if (distance !== undefined) { event.preventDefault(); menu.scrollTop += distance; }
      }, { signal });
      const canScrollMenu = (target, delta) => {
        if (!menu.contains(target)) return false;
        return delta < 0 ? menu.scrollTop > 0 : menu.scrollTop + menu.clientHeight < menu.scrollHeight - 1;
      };
      root.addEventListener('wheel', (event) => {
        if (event.ctrlKey) return;
        if (!menu.hidden && !canScrollMenu(event.target, event.deltaY)) event.preventDefault();
      }, { signal, passive: false });
      root.addEventListener('touchstart', (event) => {
        touchY = event.touches.length === 1 ? event.touches[0].clientY : null;
      }, { signal, passive: true });
      root.addEventListener('touchmove', (event) => {
        if (menu.hidden || touchY === null || event.touches.length !== 1) return;
        const delta = touchY - event.touches[0].clientY;
        touchY = event.touches[0].clientY;
        if (!canScrollMenu(event.target, delta)) event.preventDefault();
      }, { signal, passive: false });
      root.addEventListener('click', (event) => {
        const link = event.target.closest('a[href^="#lactovia-v2-"]');
        if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const target = root.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        setMenu(false);
        window.scrollTo({ top: window.scrollY + target.getBoundingClientRect().top - header.offsetHeight, behavior: reduced.matches ? 'auto' : 'smooth' });
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        window.history.replaceState(window.history.state, '', link.getAttribute('href'));
      }, { signal });
      mobile.addEventListener('change', () => { if (!mobile.matches) setMenu(false); }, { signal });

      const activate = (index) => {
        if (activeChapter === index) return;
        activeChapter = index;
        panels.forEach((panel, i) => {
          const active = !scrollStory || i === index;
          panel.classList.toggle('is-active', i === index);
          panel.inert = !active;
          if (active) panel.removeAttribute('aria-hidden'); else panel.setAttribute('aria-hidden', 'true');
        });
        chapterButtons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
      };
      const update = () => {
        ticking = false;
        const viewHeight = window.innerHeight;
        if (scrollStory) {
          const rect = story.getBoundingClientRect();
          const travel = Math.max(1, story.offsetHeight - stage.offsetHeight);
          const progress = clamp((header.offsetHeight - rect.top) / travel);
          activate(Math.min(2, Math.floor(progress * 3)));
          story.style.setProperty('--story-progress', progress.toFixed(4));
        }
        if (reduced.matches) return;
        const heroRect = hero.getBoundingClientRect();
        if (heroRect.bottom > 0 && heroRect.top < viewHeight) {
          const progress = clamp(-heroRect.top / (heroRect.height + viewHeight), -.3, 1);
          hero.style.setProperty('--hero-y', `${(progress * 40).toFixed(2)}px`);
          hero.style.setProperty('--hero-scale', (1.035 + Math.max(0, progress) * .065).toFixed(4));
        }
        const cinemaRect = cinema.getBoundingClientRect();
        if (cinemaRect.bottom > 0 && cinemaRect.top < viewHeight) {
          const progress = clamp((viewHeight - cinemaRect.top) / (viewHeight + cinemaRect.height));
          cinema.style.setProperty('--ritual-y', `${((progress - .5) * 55).toFixed(2)}px`);
        }
      };
      const requestUpdate = () => {
        if (!ticking) { ticking = true; this.frame = window.requestAnimationFrame(update); }
      };
      const configureReveals = () => {
        if (this.revealObserver) this.revealObserver.disconnect();
        if (reduced.matches || !('IntersectionObserver' in window)) {
          root.classList.remove('has-reveals');
          return;
        }
        root.classList.add('has-reveals');
        this.revealObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) { entry.target.classList.add('is-visible'); this.revealObserver.unobserve(entry.target); }
          });
        }, { threshold: .08, rootMargin: '0px 0px -25px 0px' });
        root.querySelectorAll('.reveal:not(.is-visible)').forEach((element) => this.revealObserver.observe(element));
      };
      const configure = () => {
        scrollStory = desktop.matches && !reduced.matches;
        story.classList.toggle('is-scroll-story', scrollStory);
        activeChapter = -1;
        activate(0);
        if (reduced.matches) {
          hero.style.removeProperty('--hero-y');
          hero.style.removeProperty('--hero-scale');
          cinema.style.removeProperty('--ritual-y');
        }
        configureReveals();
        requestUpdate();
      };
      chapterButtons.forEach((button) => button.addEventListener('click', () => {
        const index = Number(button.dataset.goto);
        const travel = story.offsetHeight - stage.offsetHeight;
        const progress = (index + .45) / 3;
        const top = window.scrollY + story.getBoundingClientRect().top - header.offsetHeight + travel * progress;
        window.scrollTo({ top, behavior: reduced.matches ? 'auto' : 'smooth' });
      }, { signal }));
      window.addEventListener('scroll', requestUpdate, { passive: true, signal });
      window.addEventListener('resize', requestUpdate, { passive: true, signal });
      desktop.addEventListener('change', configure, { signal });
      reduced.addEventListener('change', configure, { signal });
      configure();
    }

    disconnectedCallback() {
      if (this.closeMenu) this.closeMenu();
      if (this.controller) this.controller.abort();
      if (this.revealObserver) this.revealObserver.disconnect();
      if (this.frame) window.cancelAnimationFrame(this.frame);
      this.controller = null;
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
